import { AnimatePresence } from "framer-motion";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Navbar from "../components/Navbar";
import Design from "../pages/Design";
import Home from "../pages/Home";

import ActivityCategoriesModal from "../components/Modals/ActivityCategories/activityCategories";
import DiscardOrSaveChanges from "../components/Modals/DiscardOrSaveChanges";
import DuonutSettings from "../components/Modals/duonutSettings";
import ChangePasswordModal from "../components/Modals/Form/changePasswordModal";
import ForgotPassword from "../components/Modals/Form/forgotPassword";
import Form from "../components/Modals/Form/Form";
import LogoutModal from "../components/Modals/Logout";
import Preview from "../components/Modals/Preview";
import VideoUpload from "../components/Modals/VideoUpload";
import MyDuonut from "../pages/MyDuonut/MyDuonut";
import Pdf from "../pages/Pdf";
import Profile from "../pages/Profile";
import { RequireAuth } from "./PrivateRoute";
import ConfirmReplace from "../components/Modals/ConfirmReplace/confirmReplace";
import FromUrl from "../components/Modals/FromUrl/FromUrl";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ConfirmDeleteDuonut from "../components/Modals/ConfirmDeleteDuonut/ConfirmDeleteDuonut";
import { PreferenceModal } from "../components/Modals/PreferenceModal/Preference";

//will contain all the navigation logic
const AppRoutes = () => {
  const { modalOpen, forgotPasswordActive, changePasswordModalActive } = useSelector((state) => state.formDetails);
  const { videoModalActive } = useSelector((state) => state.activityCategories);
  const { modalOpen: previewModalOpen } = useSelector((state) => state.preview);
  const { modalOpen: settingsModalOpen } = useSelector((state) => state.duonutSettings);
  const { preferenceActive } = useSelector((state) => state.userActivity);
  const { isLoggedIn } = useSelector((state) => state.user);
  const { active: confirmReplaceModalActive } = useSelector((state) => state.sidebarSliders.confirmReplaceModal);
  const [isCreated, setIsCreated] = useState(false)
  const [loading, setLoading] = useState(false);

  return (
    <AnimatePresence>
      <BrowserRouter>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
        <>
          {forgotPasswordActive && <ForgotPassword />}
          {videoModalActive && <VideoUpload />}
          {changePasswordModalActive && <ChangePasswordModal />}
          {previewModalOpen && <Preview />}
          {settingsModalOpen && <DuonutSettings />}
          {preferenceActive && <PreferenceModal />}
          <ConfirmReplace />
          <Form />
          <ActivityCategoriesModal />
          <DiscardOrSaveChanges />
          <LogoutModal />
          <FromUrl />

          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pdf" element={<Pdf />} />
            <Route path="/pdf/:id" element={<Pdf />} />

            <Route path="/design" element={<Design editing={false} />} />
            <Route
              path="/design/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn}>
                  <Design editing={true} />
                </RequireAuth>
              }
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/allduonuts" element={<MyDuonut />} />
            <Route
              path="/myduonuts"
              element={
                <RequireAuth isLoggedIn={isLoggedIn}>
                  <MyDuonut isMyDuonuts={true} />
                </RequireAuth>
              }
            />
          </Routes>
        </>
      </BrowserRouter>
    </AnimatePresence>
  );
};

export default AppRoutes;
